import axios from "axios";
import { SalesChannel } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise("ald_sales_channels", async () =>
		(await axios.get<SalesChannel[]>(`/api/sales/channels`)).data
	);
